import { FormGroup, Input, Label } from "reactstrap";
import DefaultButton from "../../../components/Buttons/Default";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { post } from "../../../utils/helpers/api";

function NewPasswordPage() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const email = new URLSearchParams(window.location.search).get('email');
  const token = new URLSearchParams(window.location.search).get('token');

  const saveNewPassword = async () => {
    setLoading(true);
    const data = await post('/password/reset', {
      email,
      token,
      password,
      password_confirmation: passwordConfirmation
    });
    if(data.success) {
      toast.success(t('auth.passwordResetSuccess'));
      setPassword("");
      setPasswordConfirmation("");
    } else {
      toast.error(data.message || t('auth.passwordResetFailed'));
    }
    setLoading(false);
  };

  return(
    <main className="auth-page">
      <div className="auth-container">
        <div className="login-card">
          <div className="login-header">
            <h2 className="login-title">{t('profile.newPassword')}</h2>
            <p className="login-subtitle">
              {t('auth.newPasswordSubtitle')}
            </p>
          </div>

          <FormGroup>
            <Label>{t('profile.newPassword')}</Label>
            <Input
              name="password"
              type="password"
              placeholder={t('profile.newPasswordPlaceholder')}
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label>{t('profile.confirmNewPassword')}</Label>
            <Input
              name="passwordConfirmation"
              type="password"
              placeholder={t('profile.confirmNewPasswordPlaceholder')}
              required
              value={passwordConfirmation}
              onChange={(e) => setPasswordConfirmation(e.target.value)}
            />
          </FormGroup>

          <DefaultButton
            block
            onClick={saveNewPassword}
            loading={loading}
            disabled={!password || !passwordConfirmation || loading}
          >
            {t('auth.saveNewPassword')}
          </DefaultButton>

          <div className="text-center small mt-2">
            <Link to="/">{t('auth.backToLogin')}</Link>
          </div>
        </div>
      </div>
    </main>
  );
}

export default NewPasswordPage;